export function validationEmailFunc(email){
    const reqExp = /^[A-Za-z0-9{}[\]/?.,;:|)*~`!^\-_+<>#$%&=('\/\\"]+@[A-Za-z0-9{}[\]/?.,;:|)*~`!^\-_+<>#$%&=('\/\\"]+\.[A-za-z0-9{}[\]/?.,;:|)*~`!^\-_+<>#$%&=('\/\\"]+/;

    return reqExp.test(email);
}

export function validationFunc({
    input,
    minLength=1,
    maxLength=999,
    isNumber=false,
    isAlphabet=false,
    isSpecChars=false,
    isPassword=false
}) {
    const numberExp = /[0-9]/g;
    const alphabetExp = /[a-zA-Z]/g;
    const specialExp = /[{}[\]/?.,;:|)*~`!^\-_+<>@#$%&=('\/]/g;

    const notPasswordExp = /[^0-9a-zA-Z{}[\]/?.,;:|)*~`!^\-_+<>@#$%&=('\/]/g;

    input = input.trim();

    if(!input) return false;

    if(input.length<minLength) return false;

    if(input.length>maxLength) return false;

    if(isNumber && !numberExp.test(input)) return false;

    if(isAlphabet && !alphabetExp.test(input)) return false;

    if(isSpecChars && !specialExp.test(input)) return false;

    if(isPassword && notPasswordExp.test(input)) return false;

    return true;
}

